export default Object.freeze({
  FATAL: 'FATAL',
  STDERR: 'STDERR',
  ERROR: 'ERROR',
  WARN: 'WARN',
  STDOUT: 'STDOUT',
  INFO: 'INFO',
  DEBUG: 'DEBUG',
  TRACE: 'TRACE'
});
//# sourceMappingURL=LogLevel.js.map